export default "__VITE_ASSET__CQhUwz7C__"